export const ROLE_LABEL = { sales: "Vendite", marketing: "Marketing", secretary: "Segreteria", seller: "Venditore" };

// Percorsi (prefissi) consentiti per ogni ruolo del team. Il titolare (nessun team_role) vede tutto.
const ALLOWED = {
  sales: ["/", "/hermes", "/venditori", "/lead-explorer", "/processo", "/assistenza"],
  marketing: ["/", "/hermes", "/meta-ads", "/google-ads", "/clickup", "/assistenza"],
  secretary: ["/hermes", "/attivita", "/avvisi", "/whatsapp", "/persone", "/assistenza"],
  seller: ["/venditori", "/lead-explorer", "/hermes", "/assistenza"],
};

export const canSee = (user, to) => {
  const role = user?.team_role;
  if (!role) return true;
  const list = ALLOWED[role] || [];
  return list.some((p) => (p === "/" ? to === "/" : to === p || to.startsWith(`${p}/`)));
};

export const homeFor = (user) => {
  switch (user?.team_role) {
    case "marketing": return "/";
    case "secretary": return "/attivita";
    case "seller": return user.seller_ghl_id ? `/venditori/${user.seller_ghl_id}` : "/venditori";
    default: return "/";
  }
};

export const dashboardViewFor = (user) => (user?.team_role === "marketing" ? "marketing" : user?.team_role === "sales" ? "commerciale" : null);
